import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/snapshots']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getQuestionnaireSnapshots = async ({ page, perPage, questionnaireId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/snapshots', { questionnaireId });
  const data = await formsBackendClient.get(path, {
    params: {
      page,
      perPage,
    },
  });
  return data.data;
};

export default getQuestionnaireSnapshots;
